import { connect } from 'react-redux';

import ConsentModal from './consent_modal.jsx';

import { getConsentProps } from 'zoomforth_codesbane_viewer/reducers/index.js';
import { setConsentProps  } from 'zoomforth_codesbane_viewer/action_creators/consent.js';

const mapStateToProps = (state)=> {
  const {
    routeId,
    isConsentRequired,
    isConsentCookieSet,
    hasConsentedToTracking,
    hasConsentedToAuthCookie,
    privacyPolicyUrl
  } = getConsentProps(state);

  return {
    routeId,
    isConsentRequired,
    isConsentCookieSet,
    hasConsentedToTracking,
    hasConsentedToAuthCookie,
    privacyPolicyUrl
  };
};

const mapDispatchToProps = (dispatch)=> {
  return {
    onConsentChange: (consentProps)=> {
      dispatch(setConsentProps(consentProps));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsentModal);
